import React, { useEffect, useState, useReducer, Fragment } from 'react';
import moment from 'moment'
import ReactTable from 'react-table';
import Loader from '../../common/loader';
import api from '../../../config/axios';
import { date, time, dateQuery } from '../../../utils/date';
import miscUtils from '../../../utils/miscUtils';
import { useStateValue } from '../../../store';
import { getTimeFormat, getShortBottlesPurchase } from '../../sales/utils';
import { DateRangePicker } from 'react-dates';
import PrintUserId from './print_id';
import { getSalesSummary, formatProducts, formatAmounts, formatObservations } from '../utils';

const columnsDataTable = (count, role, inputFilter) => [
    {
        Header: role !== 'DELIVERY' ? <b>{`${count} pedidos`}</b> : null,
        id: 'delete',
        accessor: (str) => 'delete',
        Cell: (row) => (
            <div className="wrapper-order-item" style={inputFilter === String(row.original.id) ? { backgroundColor: 'yellow' } : {}}>
                <div className="wrapper-top-details">
                    <p className="status-order mt-0 mb-2">
                        {row.original.estado}&nbsp;{row.original.carreraLarga}
                    </p>
                    <p>
                        <i className="fa fa-clock-o"></i> {row.original.entrega}
                    </p>
                </div>
                <div className="wrapper-quantity-order">
                    <h4 className="quantity-order">{row.original.cantidad}</h4>
                    <p style={{ fontWeight: 'bold', color: 'black' }}>
                        {!row.original.subscription ? (
                            row.original.paymentMethod.name.split('(')[0]
                        ) : (
                            <span>
                                N/A <strong>(recargas a favor)</strong>
                            </span>
                        )}
                        {row.original.couponId && <strong>(cupón)</strong>}
                        {row.original.payment_confirmation_id && (
                            <strong style={{ color: '#666' }}>
                                ({row.original.payment_confirmation_id})
                            </strong>
                        )}
                    </p>
                </div>
                <h4 style={{ color: row.original.observation ? 'red' : '', fontWeight: 400 }}>
                    {row.original.cliente}
                </h4>
                <span style={{ color: 'red', fontSize: 12 }}>
                    {row.original.observationImage && `(Foto)`}
                    {row.original.observation}
                </span>
                <div className="wrapper-bottom-description mt-1">
                    <p className="m-0">{row.original.direccion}</p>
                    <p >{row.original.id}</p>
                </div>
            </div>
        ),
        style: {
            textAlign: 'center',
            width: '100%',
        },
        sortable: false,
        width: '100%',
    },
];

const getFirstAndLastDateOfTheWeek = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dayOfWeek = today.getDay(); // 0=Dom, 1=Lun, ..., 6=Sáb

    // Días a restar para llegar al sábado anterior (o hoy si es sábado)
    // Sáb=6 → 0, Dom=0 → 1, Lun=1 → 2, Mar=2 → 3, Mié=3 → 4, Jue=4 → 5, Vie=5 → 6
    const daysToSaturday = dayOfWeek === 6 ? 0 : dayOfWeek + 1;

    const first = new Date(today);
    first.setDate(today.getDate() - daysToSaturday);

    const last = new Date(first);
    last.setDate(first.getDate() + 6); // Sábado + 6 días = Viernes

    var lunes = new Date(today.setDate(today.getDate() - today.getDay() + 1)); // lunes
    var sabado = new Date(today.setDate(lunes.getDate() + 6)); // sábado

    // sabado a viernes
    return { first, last };
};

const getDatesRange = (type, customDates) => {
    let dates = { startDate: null, endDate: null };
    let startDate = new Date();
    let endDate = new Date();

    switch (type) {
        case 'week':
            const { first, last } = getFirstAndLastDateOfTheWeek()
            endDate = last
            dates.endDate = dateQuery(endDate);
            startDate = first
            dates.startDate = dateQuery(startDate);
            break;
        case 'custom':
            dates.startDate = dateQuery(new Date(customDates.startDate));
            dates.endDate = dateQuery(new Date(customDates.endDate));
            break;
        case 'currently-month':
            dates.startDate = dateQuery(new Date(startDate.getFullYear(), startDate.getMonth(), 1));
            dates.endDate = dateQuery(new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0));
            break;
        case 'last-month':
            dates.startDate = dateQuery(
                new Date(startDate.getFullYear(), startDate.getMonth() - 1, 1),
            );
            dates.endDate = dateQuery(new Date(endDate.getFullYear(), endDate.getMonth(), 0));
            break;
    }
    return dates;
};

const getLastTransaction = (transactions) =>
    transactions.reduce((a, b) => (a.createdAt > b.createdAt ? a : b));


function Orders(props) {
    const userId = props.match.params.userId;
    const [{ auth }] = useStateValue();
    const [filterOrders, setFilterOrders] = useState('week');
    const [inputFilter, setInputFilter] = useState('')
    const [dates, setDates] = useState({
        startDate: null,
        endDate: null,
    });
    const [focusStartDate, setFocusStartDate] = useState('');
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        resolved: false,
        loading: true,
        data: {
            user: null,
            orders: null,
            originalOrders: null,
            pagination: { page: 1 },
        },
        error: null,
    });
    const [onlyObservations, setOnlyObservations] = useState(false)

    useEffect(() => {
        if (dates.startDate && dates.endDate) {
            setFilterOrders('custom');
        } else {
            setFilterOrders('week');
        }
    }, [dates]);

    useEffect(() => {
        handleOnlyObservations();
    }, [onlyObservations])

    useEffect(() => {
        setState({
            resolved: false,
            loading: true,
            data: {
                ...state.data,
                orders: null,
                user: null,
            },
            error: null,
        });
        const { startDate, endDate } = getDatesRange(filterOrders, dates);
        fetchOrders(state.data.pagination.page, startDate, endDate);
    }, [filterOrders]);

    const fetchOrders = async (page, startDate, endDate) => {
        const { data } = await api.get(
            `purchase/users?page=${page}&startDate=${startDate}&endDate=${endDate}&userId=${userId}`,
        );

        const responseUser = await api.get(`user/${userId}`)

        // mostrar todas las ordenes (creadas, enviadas y entregadas)

        const orders = parseToDatatable(data.data.rows);

        const dataPagination = {
            ...data.meta.pagination,
            total: data.data.rows.length,
        };

        setState({
            resolved: true,
            loading: false,
            data: {
                orders,
                originalOrders: orders,
                pagination: dataPagination,
                pageTable: data.meta.pagination.page - 1,
                user: responseUser.data.data,
            },
            error: null,
        });

    };

    const parseToDatatable = (array) => {
        const parsed = array.map((item) => {
            const lastTransaction = item.transactions.reduce((a, b) =>
                a.createdAt > b.createdAt ? a : b,
            );

            const firstTransaction = item.transactions.reduce((a, b) =>
                b.createdAt > a.createdAt ? a : b,
            );

            const productRecargas = item.products.find((item) => item.name === 'Recarga');

            const quantityOrder = productRecargas
                ? getShortBottlesPurchase(
                    productRecargas.purchaseProducts.quantity,
                    item.address.newBottles,
                )
                : '';

            const itemFormatted = {
                id: item.id,
                requestedFrom: item.requestedFrom,
                estado: renderBadge(lastTransaction.name),
                carreraLarga: item.address.longway ? renderLongway() : null,
                entrega: `${item.delivery_time
                    ? getTimeFormat(item.delivery_time)
                    : `${time(firstTransaction.createdAt)} - Express`
                    }`,
                'fecha de pedido': `${date(item.createdAt)} ${time(firstTransaction.createdAt)}`,
                cantidad: miscUtils.renderTextPedido(item),
                products: item.products,
                quantityDescription: quantityOrder,
                cliente: item.client ? item.client.name : `${item.nameQuick} (CNR)`,
                direccion: item.address ? item.address.street1 : item.addressQuick,
                user: item.user,
                paymentMethod: item.paymentMethod,
                observation: purchaseWithNotes(item.purchasesByAddress.slice(0, 2)),
                observationImage: purchaseWithImage(item.purchasesByAddress.slice(0, 2)),
                couponId: item.couponId,
                payment_confirmation_id: item.payment_confirmation_id,
                subscription: item.subscriptionId,
            };

            return itemFormatted;
        });
        return parsed;
    };

    const renderBadge = (status) => {
        switch (status) {
            case 'Pedido Creado':
                return <span className="badge badge-warning">Creado</span>;
            case 'Pedido Cancelado':
                return <span className="badge badge-danger">Cancelado</span>;
            case 'Pedido Enviado':
                return <span className="badge badge-info">Enviado</span>;
            case 'Pedido Recibido':
                return <span className="badge badge-success">Recibido</span>;
            case 'Pedido Entregado':
                return <span className="badge badge-success">Entregado</span>;
            case 'Pedido Rechazado':
                return <span className="badge badge-danger">Rechazado</span>;
            case 'Pago Confirmado':
                return <span className="badge badge-warning">Pago Confirmado</span>;
            default:
                return null;
        }
    };

    const renderLongway = () => <span className="badge badge-info">Larga</span>;

    const handlePage = (page) => {
        const { startDate, endDate } = getDatesRange(filterOrders);
        fetchOrders(page, startDate, endDate);
    };

    const totalPages = () => Math.ceil(state.data.pagination.total / state.data.pagination.length);

    /**
     * Obtiene las observaciones de las compras anteriores
     * Retorna observación solo si la oldPurchase más reciente tiene observación
     * @param {Array} oldPurchases
     * @returns {string|null}
     */
    const purchaseWithNotes = (lastPurchases) => {
        // Validar si lastPurchases existe y tiene elementos
        if (!lastPurchases || lastPurchases.length === 0) {
            return null;
        }

        // Si solo hay una compra
        if (lastPurchases.length === 1) {
            const purchase = lastPurchases[0];
            const hasObservation = purchase.transactions.find(
                (transaction) => !!transaction.observation,
            );
            return hasObservation ? hasObservation.observation : null;
        }

        // Si hay dos compras (caso original)
        if (lastPurchases.length === 2) {
            // Ordenar lastPurchases por id para identificar cuál es más reciente
            const sortedOldPurchases = lastPurchases.sort((a, b) => a.id - b.id);
            const oldestPurchase = sortedOldPurchases[0];
            const newestPurchase = sortedOldPurchases[1];

            // Verificar si cada purchase tiene observación
            const oldestHasObservation = oldestPurchase.transactions.find(
                (transaction) => !!transaction.observation,
            );
            const newestHasObservation = newestPurchase.transactions.find(
                (transaction) => !!transaction.observation,
            );

            // Caso 1: Ambas tienen observación - retornar ambas identificando cuál es más reciente
            if (oldestHasObservation && newestHasObservation) {
                const oldestObservation = oldestHasObservation.observation;
                const newestObservation = newestHasObservation.observation;
                return `Reciente: ${newestObservation} Antigua: ${oldestObservation}`;
            }

            // Caso 2: Solo la más reciente tiene observación - retornar el texto
            if (newestHasObservation) {
                return newestHasObservation.observation;
            }

            // Caso 3: Solo la más antigua tiene observación - retornar null
            if (oldestHasObservation) {
                return `(antigua) ${oldestHasObservation.observation}`;
            }

            // Caso 4: Ninguna tiene observación - retornar null
            return null;
        }
    };

    const purchaseWithImage = (lastPurchases) => {
        if (!lastPurchases || lastPurchases.length === 0) {
            return null;
        }
        if (lastPurchases.length === 1) {
            return lastPurchases[0].imageObservation;
        }

        // Si hay dos compras (caso original)
        if (lastPurchases.length === 2) {
            // Ordenar lastPurchases por id para identificar cuál es más reciente
            const sortedOldPurchases = lastPurchases.sort((a, b) => a.id - b.id);
            const oldestPurchase = sortedOldPurchases[0];
            const newestPurchase = sortedOldPurchases[1];

            // Verificar si cada purchase tiene observación
            const oldestHasObservation = oldestPurchase.transactions.find(
                (transaction) => !!transaction.imageObservation,
            );
            const newestHasObservation = newestPurchase.transactions.find(
                (transaction) => !!transaction.imageObservation,
            );

            // Caso 1: Solo la más reciente tiene observación - retornar el texto
            if (newestHasObservation) {
                return newestHasObservation.imageObservation;
            }

            // Caso 2: La más antigua tiene observación y la más reciente no ha sido entregada - retornar la observación de la más antigua
            if (
                oldestHasObservation &&
                !newestPurchase.transactions.find(
                    (transaction) => transaction.name === 'Pedido Entregado',
                )
            ) {
                return oldestHasObservation.imageObservation;
            }

            // Caso 3: Solo la más antigua tiene observación - retornar null
            if (oldestHasObservation) {
                return null;
            }

            // Caso 4: Ninguna tiene observación - retornar null
            return null;
        }
        return null;
    };

    const filterListOrders = () => {
        // filtrar desde el código dado para acortar distancias
        const index = state.data.orders.findIndex(item => String(item.id) === String(inputFilter));

        const newList = index !== -1
            ? state.data.orders.slice(0, index + 1)
            : state.data.orders;

        setState({
            resolved: true,
            loading: false,
            data: {
                ...state.data,
                orders: newList,
                originalOrders: state.data.orders
            },
        });
    }

    const handleOnlyObservations = () => {
        let newOrders = null;
        if (onlyObservations) {
            newOrders = state.data.orders.filter(o => o.observation && o.observation !== '')
        } else {
            newOrders = state.data.originalOrders
        }
        setState({
            resolved: true,
            loading: false,
            data: {
                ...state.data,
                orders: newOrders,
                originalOrders: state.data.orders
            },
        });
    }

    const resetListOrders = () => {
        setInputFilter('')
        setState({
            resolved: true,
            loading: false,
            data: {
                ...state.data,
                orders: state.data.originalOrders
            },
        });
    }

    if (state.loading)
        return (
            <div style={{ display: 'flex', height: '50vh' }}>
                <Loader />
            </div>
        );

    const columns = columnsDataTable(state.data.pagination.total, auth.user.role, String(inputFilter))
    const summary = getSalesSummary(state.data.orders)

    const summaryProducts = formatProducts(summary.products);
    // 20 recargas, 4 recarga pequeños, 1 envase nuevo

    const summaryAmounts = formatAmounts(summary.amounts);
    // 240.000 pesos y 34 dólares

    const summaryObservations = formatObservations(summary.observations);
    // 7 observaciones

    const { startDate, endDate } = getDatesRange(filterOrders, dates)

    return (
        <Fragment>
            <div className="container-fluid rents-wrapper wrapper-print no-print">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card" style={{ marginBottom: '12px', marginTop: '12px' }}>
                            <div className="card-body">
                                <div>
                                    <div className="col-xl-6 col-8 col-sm-12">
                                        <label>Rango de fecha</label>
                                    </div>
                                    <div className="col-xl-6 col-8 col-sm-12">
                                        <DateRangePicker
                                            startDate={dates.startDate} // momentPropTypes.momentObj or null,
                                            startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                            endDate={dates.endDate} // momentPropTypes.momentObj or null,
                                            endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                            onDatesChange={(dates) => {
                                                setDates(dates);
                                            }} // PropTypes.func.isRequired,
                                            focusedInput={focusStartDate} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                            onFocusChange={(d) => setFocusStartDate(d)} // PropTypes.func.isRequired,
                                            isOutsideRange={() => false}
                                            initialVisibleMonth={() => moment().subtract(1, 'month')}
                                        />
                                    </div>
                                    <div className="row pt-2 pl-3">
                                        <div className="col-xl-6 col-8 col-sm-12">
                                            <div className="form-group">
                                                <label>Buscar desde</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Escriba código aquí"
                                                    name="inputFilter"
                                                    onChange={e => setInputFilter(e.target.value)}
                                                    value={inputFilter}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pb-3 pl-3">
                                        <div className="col-xl-6 col-8 col-sm-12">
                                            <div className="form-group">
                                                <label>Filtrar observaciones</label>
                                                <input
                                                    type="checkbox"
                                                    className="d-block"
                                                    name="inputFilterObservations"
                                                    onChange={e => setOnlyObservations(!onlyObservations)}
                                                    value={onlyObservations}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary"
                                            type="submit"
                                            onClick={filterListOrders}
                                        >
                                            <i className="fa fa-search"></i>
                                        </button>
                                        &nbsp;
                                        <button
                                            className="btn btn-secondary"
                                            type="submit"
                                            onClick={resetListOrders}
                                        >
                                            <i className="fa fa-close"></i>
                                        </button>
                                        &nbsp;
                                        <button className="btn btn-success" onClick={() => window.print()}>
                                            <i className="fa fa-print"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card" style={{ marginBottom: '12px' }}>
                            <div className="card-body p-3">
                                <p>{state.data.user.name} (<strong>{startDate} - {endDate}</strong>)</p>
                                <p className="m-0 p-0">Productos: <strong>{summaryProducts}</strong></p>
                                <p className="m-0 p-0">Monto: <strong>{summaryAmounts}</strong></p>
                                <p className="m-0 p-0">{summaryObservations}</p>
                            </div>
                        </div>
                        <div className="card" style={{ marginBottom: '12px' }}>
                            <div className="card-body">
                                <div id="basicScenario" className="order-list">
                                    <ReactTable
                                        columns={columns}
                                        className="-striped "
                                        multiSelectOption={false}
                                        data={state.data.orders}
                                        page={state.data.pageTable}
                                        pages={totalPages()}
                                        defaultPageSize={columns.length}
                                        showPageSizeOptions={false}
                                        onPageChange={(index) => handlePage(index + 1)}
                                        manual
                                        nextText="Siguiente"
                                        previousText="Anterior"
                                        getTrProps={(state, rowInfo, column, instance) => ({
                                            onClick: (e) =>
                                                props.history.push(
                                                    `/recargas/detalle/${rowInfo.original.id}`,
                                                ),
                                        })}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PrintUserId orders={state.data.orders} user={state.data.user} dates={getDatesRange(filterOrders, dates)} />
        </Fragment>
    );
}

export default Orders;
